import React from 'react';

import moment from 'moment-timezone';

import Button from 'components/shared/Buttons/Button/Button';
import Popover from 'components/shared/Popovers/Popover/Popover';

const Months = ({ currentMonth, changeMonthHandle }) => {
  const dateFormat = 'MMMM';
  const formattedMonth = moment(currentMonth).format(dateFormat);
  const months = moment.months();

  const handleMonthSelect = (selectedMonth, handleClose) => {
    const newDate = moment(currentMonth).month(selectedMonth.value);

    changeMonthHandle(newDate);
    handleClose();
  };

  const monthOptions = months.map((month) => ({
    label: month,
    value: month
  }));

  return (
    <Popover
      options={monthOptions}
      onOptionClick={handleMonthSelect}
      customButtonTrigger={
        <Button
          text={formattedMonth}
          variant="tertiary"
          iconRight="chevron-down-linear"
          iconColor="neutral"
          size="xs"
        />
      }
    />
  );
};

export default Months;
